import type { BlogPostDetailResult } from '../data/BlogPostFragment'
import type { BrandDetailResult } from '../data/BrandFragment'
import type { ItemCategoryDetailResult } from '../data/ItemCategoryFragment'
import type { ItemDetailResult } from '../data/ItemFragment'
import type { ProductDetailResult } from '../data/ProductFragment'
import type { ProductLineDetailResult } from '../data/ProductLineFragment'
import type { SeoResult } from '../data/SeoFragment'

export const nullableString = (value: string | undefined) => {
	if (value === '') {
		return null
	}
	return value
}

export function setSeoProduct(item: ProductDetailResult | undefined, description: string) {
	return {
		id: `${item?.id}/seo`,
		title:
			nullableString(item?.seo?.title) || item?.productLine?.id
				? `Recenze: ${item?.brand?.name} ${item?.productLine?.name} ${item?.name} - hodnocení ${item?.score} % `
				: `Recenze: ${item?.brand?.name} ${item?.name} - hodnocení ${item?.score} % `,
		description: nullableString(item?.seo?.description) || description,
		ogImage: item?.seo?.ogImage || item?.image,
		ogTitle:
			nullableString(item?.seo?.title) || item?.productLine?.id
				? `${item?.brand?.name} ${item?.productLine?.name} ${item?.name}`
				: `${item?.brand?.name} ${item?.name}`,
		ogDescription: nullableString(item?.seo?.ogDescription) || description,
	}
}

export function setSeoBrand(item: BrandDetailResult | undefined) {
	return {
		id: `${item?.id}/seo`,
		title: nullableString(item?.seo?.title) || item?.name,
		description: nullableString(item?.seo?.description) || item?.customMetaDescription || item?.lead,
		ogImage: item?.seo?.ogImage || item?.logo,
		ogTitle: nullableString(item?.seo?.ogTitle) || item?.name,
		ogDescription: nullableString(item?.seo?.ogDescription) || item?.customMetaDescription || item?.lead,
	}
}

export function setSeoResults(title: string, subtitle: string, url: string) {
	return {
		id: `${url}/seo`,
		title,
		ogTitle: title,
		description: subtitle,
		ogDescription: subtitle,
	}
}

export function setSeoIngredient(item: ItemDetailResult | undefined) {
	return {
		id: `${item?.id}/seo`,
		title: nullableString(item?.seo?.title) || item?.name,
		description: nullableString(item?.seo?.description) || item?.lead,
		ogImage: item?.seo?.ogImage || item?.image,
		ogTitle: nullableString(item?.seo?.ogTitle) || item?.name,
		ogDescription: nullableString(item?.seo?.ogDescription) || item?.lead,
	}
}

export function setSeoProductLine(item: ProductLineDetailResult | undefined) {
	return {
		id: `${item?.id}/seo`,
		title: nullableString(item?.seo?.title) || `${item?.brand?.name} ${item?.name}`,
		description: nullableString(item?.seo?.description) || item?.customMetaDescription || item?.lead,
		ogImage: item?.seo?.ogImage || item?.logo,
		ogTitle: nullableString(item?.seo?.ogTitle) || item?.name,
		ogDescription: nullableString(item?.seo?.ogDescription) || item?.customMetaDescription || item?.lead,
	}
}

export function setSeoBlogPost(item: BlogPostDetailResult | undefined) {
	return {
		id: `${item?.id}/seo`,
		title: nullableString(item?.seo?.title) || item?.title,
		description: nullableString(item?.seo?.description) || item?.lead,
		ogImage: item?.seo?.ogImage || item?.image,
		ogTitle: nullableString(item?.seo?.ogTitle) || item?.title,
		ogDescription: nullableString(item?.seo?.ogDescription) || item?.lead,
	}
}

export function setSeoCategory(item: ItemCategoryDetailResult | undefined) {
	return {
		id: `${item?.id}/seo`,
		title: nullableString(item?.seo?.title) || item?.name,
		description: nullableString(item?.seo?.description) || item?.shortDescription,
		ogImage: item?.seo?.ogImage || item?.image,
		ogTitle: nullableString(item?.seo?.ogTitle) || item?.name,
		ogDescription: nullableString(item?.seo?.ogDescription) || item?.shortDescription,
	}
}

export function setSeoSearch(value: string, pageSeo: SeoResult | undefined) {
	return {
		id: `${pageSeo?.id}/seo`,
		title: `${pageSeo?.title}: ${value} `,
		description: pageSeo?.description,
		ogImage: pageSeo?.ogImage,
		ogTitle: `${value} ${pageSeo?.ogTitle}`,
		ogDescription: pageSeo?.description,
	}
}

export function setSeoTitle(id: string, title: string) {
	return {
		id: `${id}/seo`,
		title: title,
		ogTitle: title,
	}
}
